import {
  getLocaleFromPathname,
  getLocaleString,
} from 'typescript/utilities/locales';
import { getDomain } from 'typescript/utilities/environment';

export const buildLegalLink = (predicate: string) =>
  `${getLocaleFromPathname()}/legal/general${predicate}`;

export const getLegalUrls = (applicationFlowToken: string | null = null) => {
  return {
    hardwareUrl: buildLegalLink('/hardware'),
    privacyUrl: buildLegalLink('/privacy'),
    recurringUrl: buildLegalLink(
      '/shop-recurring-electronic-payment-authorization',
    ),
    installmentUrl: applicationFlowToken
      ? `https://${getDomain('app.')}/api/v2/capital-shop/documents/square-installment-sales-agreement/${applicationFlowToken}/${getLocaleString()}`
      : null,
    esignUrl: buildLegalLink('/sign'),
    creditUrl: buildLegalLink('/shop-credit-authorization'),
  };
};
